import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="w-full py-24 md:py-32 bg-[var(--warm-cream)]" data-id="element-14">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-15">
        {/* Title centered above on mobile, hidden on desktop where it's in the right column */}
        <div className="flex md:hidden items-center justify-center gap-3 mb-10 whitespace-nowrap" data-id="element-16">
          <div className="w-6 h-[1px] bg-[#D4AF37]" data-id="element-17"></div>
          <h2 className="font-serif text-lg tracking-[0.2em] uppercase text-[#C9956A]" data-id="element-18">
            Quién es Iara Oliver
          </h2>
          <div className="w-6 h-[1px] bg-[#D4AF37]" data-id="element-19"></div>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-24" data-id="element-20">
          {/* Left Column: Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 relative" data-id="element-21">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[3/4] max-w-md mx-auto" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/2jTX2Pt18NYdXH3ayFecxe/foto_de_la_dueNa.png" alt="Iara Oliver" className="w-full h-full object-cover" data-id="element-23" />
              <div className="absolute inset-0 border border-[#D4AF37]/30 rounded-2xl m-4 pointer-events-none" data-id="element-24"></div>
            </div>
            {/* Decorative element behind image */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-[#D4AF37]/20 rounded-full -z-10" data-id="element-25"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 border border-[#D4AF37]/20 rounded-full -z-10" data-id="element-26"></div>
          </motion.div>

          {/* Right Column: Bio */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="w-full md:w-1/2 flex flex-col justify-center" data-id="element-27">
            <div className="hidden md:flex items-center gap-4 mb-6" data-id="element-28">
              <div className="w-12 h-[1px] bg-[#D4AF37]" data-id="element-29"></div>
              <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A]" data-id="element-30">
                Quién es Iara Oliver
              </h2>
            </div>

            <blockquote className="relative pl-6 border-l-2 border-[#D4AF37] mb-10" data-id="element-31">
              <p className="font-serif italic text-2xl md:text-3xl text-[#2C1810] leading-relaxed" data-id="element-32">
                "Mi propósito no es solo estético: quiero que cada persona se
                reconozca, se guste y se sienta segura con lo que refleja en el
                espejo."
              </p>
            </blockquote>

            <div className="space-y-6 text-[#5C3D2E] font-light leading-relaxed" data-id="element-33">
              <p data-id="element-34">
                Iara lleva más de 6 años acompañando a personas que buscan verse
                y sentirse mejor.
              </p>
              <p data-id="element-35">
                No empezó con un local grande ni con una agenda llena de
                clientes. Empezó con una convicción:{' '}
                <span className="font-medium" data-id="element-36">
                  Puedo cambiarle la forma de verse al espejo a alguien.
                </span>
              </p>
              <p data-id="element-37">
                Desde entonces no paró de formarse. Viajó. Aprendió de los
                mejores referentes de la industria. Volvió puliendo cada
                técnica, cada nuevo conocimiento y perspectiva diferente — y lo
                volcó todo en su trabajo en Rosario.
              </p>
              <p data-id="element-38">
                Hoy, además de atender a sus clientas, forma a nuevas
                profesionales — porque cree que una estética consciente,
                responsable y con propósito puede transformar no solo rostros,
                sino profesiones enteras.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Centered closing statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-16 text-center max-w-2xl mx-auto" data-id="element-39">
          <div className="w-16 h-[1px] bg-[#D4AF37]/40 mx-auto mb-8" data-id="element-40"></div>
          <p className="font-serif text-2xl md:text-3xl text-[#2C1810] leading-relaxed" data-id="element-41">
            Cuando entrás al local de Iara, no entrás a un turno más. Entrás a
            una experiencia pensada para vos.
          </p>
          <div className="w-16 h-[1px] bg-[#D4AF37]/40 mx-auto mt-8" data-id="element-42"></div>
        </motion.div>
      </div>
    </section>;
}